export const DIRECT_SEARCH_PREFIXES = [
  { prefix: "CN", description: "Control Number", example: "CN:12575866" },
  { prefix: "PN", description: "Policy or Loan Number", example: "PN:1218080761" },
  { prefix: "STA", description: "State of Property or Mailing Address", example: "STA:NY" },
  { prefix: "ZIP", description: "Zip Code of Property or Mailing Address", example: "ZIP:14150" },
  { prefix: "TRA", description: "Tracking Number", example: "TRA:3263827" },
  { prefix: "CUS", description: "Customer Number", example: "CUS:1138" },
  { prefix: "PH", description: "Policy Holder Name", example: "PH:John Doe" },
  { prefix: "PHN", description: "Policy Holder Number", example: "PHN:8008758339" },    
  { prefix: "DCN", description: "Designated Contact Name", example: "DCN:john doe" },
  { prefix: "DCP", description: "Designated Contact Phone", example: "DCP:8008758339" },
  { prefix: "DCP2", description: "Designated Contact Phone 2", example: "DCP2:8008758339" },
  { prefix: "DCE", description: "Designated Contact Email", example: "DCE:john.doe@example.com" },
  { prefix: "FR", description: "Field Rep Number", example: "FR:2119" },
  { prefix: "AN", description: "Appraiser Number", example: "AN:117" },
  { prefix: "LC", description: "LC360 Inspection Number", example: "LC:12345" },
];
